import React, { Component } from 'react';
import Nav from './Nav';
import Header from './Header';
import Work from './Work';
import About from './About';
import Contact from './Contact';

class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			work: 0,
			about: 0,
			contact: 0
		};
	}
	componentDidMount() {
		this.changeUrlOnScroll();
	}

	getDivStart = (id, val) => {
		this.setState({
			[id]: val
		});
	};

	componentWillUnmount() {
		this.removeScroll();
	}

	scrollHistory = () => {
		const buffer = 1;
		switch (true) {
			case window.scrollY < this.state.work - buffer:
				return window.history.pushState(
					'data',
					'header',
					`${process.env.PUBLIC_URL}/`
				);
			case window.scrollY >= this.state.work - buffer &&
				window.scrollY < this.state.about - buffer:
				return window.history.pushState(
					'data',
					'work',
					`${process.env.PUBLIC_URL}/#work`
				);
			case window.scrollY >= this.state.about - buffer &&
				window.scrollY < this.state.contact - buffer:
				return window.history.pushState(
					'data',
					'about',
					`${process.env.PUBLIC_URL}/#about`
				);
			case window.scrollY >= this.state.contact - buffer:
				return window.history.pushState(
					'data',
					'contact',
					`${process.env.PUBLIC_URL}/#contact`
				);
			default:
				return;
		}
	};

	changeUrlOnScroll = () => {
		window.addEventListener('scroll', this.scrollHistory);
	};

	removeScroll = () => {
		window.removeEventListener('scroll', this.scrollHistory);
	};

	render() {
		return (
			<React.Fragment>
				<Nav />
				<Header />
				<main className="content">
					<Work
						projects={this.props.projects}
						divStart={this.getDivStart}
					/>
					<About divStart={this.getDivStart} />
					<Contact divStart={this.getDivStart} />
				</main>
			</React.Fragment>
		);
	}
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js